export default function BadgeComponent({ color, title, icon, onClick }) {
    const dotStyle = {
      backgroundColor: color
    }
    return (
      <div onClick={onClick} className="flex flex-row rounded-[6px] items-center px-[16px] py-[6px] gap-4 cursor-pointer" style={dotStyle}>
        <div className="text-[16px] font-bold">{title}</div>
        <img src={icon} className="w-[20px] h-[30px]" />
      </div>
    )
}